import React, { useEffect, useMemo, useCallback } from 'react';
import { BottomNavigation, BottomNavigationAction, Badge } from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import useStyles from './styles';
import { useAuth } from 'utils/useAuth';
import useSW from '../../store/sw';
import {
  FaHome as WelcomeIcon,
  FaChartPie as DashboardIcon,
  FaChartLine as PerformanceIcon,
  FaImage as ImageIcon,
  FaBullhorn as ExposureIcon,
  FaInfo as AboutIcon,
  FaSignInAlt as LoginIcon,
  FaSignOutAlt as LogoutIcon,
  FaRedo as UpdateIcon
} from 'react-icons/fa';

function BottomNavigation_() {
  const classes = useStyles().classes;
  const [value, setValue] = React.useState('');
  const { user, logout } = useAuth();
  const [swState, swActions] = useSW();
  const location = useLocation();
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAppUpdate = () => {
    swActions.update();
  };

  const handleLogout = useCallback(async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  }, [logout, navigate]);

  const navigationItems = useMemo(() => 
    user
      ? [
          { label: 'Dashboard', icon: DashboardIcon, path: '/Dashboard' },
          { label: 'Performance', icon: PerformanceIcon, path: '/Performance' },
          { label: 'Image', icon: ImageIcon, path: '/Image' },
          { label: 'Exposure', icon: ExposureIcon, path: '/Exposure' },
          { label: 'Logout', icon: LogoutIcon, path: '/logout', onClick: handleLogout },
        ]
      : [
          { label: 'Home', icon: WelcomeIcon, path: '/' },
          { label: 'About Us', icon: AboutIcon, path: '/AboutUs' },
          { label: 'Login', icon: LoginIcon, path: '/Login' },
        ],
    [user, handleLogout]
  );

  useEffect(() => {
    const currentPath = location.pathname;
    const currentItem = navigationItems.find(item => item.path === currentPath);
    if (currentItem) {
      setValue(currentItem.path);
    } else {
      setValue('');
    }
  }, [location, navigationItems]);

  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      className={classes.stickToBottom}
    >
      {navigationItems.map((item) => (
        <BottomNavigationAction 
          key={item.path}
          label={item.label}
          icon={<item.icon />}
          component={item.onClick ? 'button' : RouterLink}
          to={item.onClick ? undefined : item.path}
          onClick={item.onClick}
          value={item.path}
        />
      ))}
      {swState.isUpdated && (
        <BottomNavigationAction
          label="Update"
          icon={
            <Badge color="secondary" variant="dot">
              <UpdateIcon />
            </Badge>
          }
          onClick={handleAppUpdate}
        />
      )}
    </BottomNavigation>
  );
}

export default BottomNavigation_;